import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthenticatedSessionProvider } from './context/authenticatedUser';
import FireStarter from './components/FireStarter';
import FirebaseAuthCheck from './components/FirebaseAuthCheck';

ReactDOM.render(
    <React.StrictMode>
        <AuthenticatedSessionProvider>
            <FireStarter>
                <FirebaseAuthCheck>
                <App />
                </FirebaseAuthCheck>
            </FireStarter>
        </AuthenticatedSessionProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
